module.exports = __webpack_public_path__ + "img/feature-2.27da89cc.jpg";